"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext } from "react";
import { useServerConfiguration } from "@/contexts/server-configuration/server-configuration.context";
import { useSite } from "@/contexts/site/site.context";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import type { AuthenticationProviderProps } from "@/vendors/authentication/contexts/AuthenticationProvider.context";
import type { UseAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
import { keycloakConfiguration, keycloakStrategy } from "../keycloak.strategy";
export const UserKeycloakAuthenticationContext = createContext<undefined | UseAuthentication>(undefined);
export function KeycloakAuthenticationUserProvider(t0) {
  const $ = _c(19);
  const {
    children,
    user
  } = t0;
  const siteModel = useSite();
  const {
    keycloakAuthUrl
  } = useServerConfiguration();
  const {
    absoluteDomainName
  } = useCurrentUrl();
  const {
    urls: strategyUrls
  } = keycloakStrategy;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = redirect => strategyUrls.createLogin({
      redirect
    });
    t2 = redirect_0 => strategyUrls.createLogout({
      redirect: redirect_0
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== absoluteDomainName || $[3] !== keycloakAuthUrl) {
    t3 = redirect_1 => strategyUrls.createLogoutToLogin({
      absoluteDomainName,
      providerUrl: keycloakAuthUrl,
      redirect: redirect_1
    });
    $[2] = absoluteDomainName;
    $[3] = keycloakAuthUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] !== absoluteDomainName) {
    t4 = redirect_2 => strategyUrls.createProfile({
      absoluteDomainName,
      redirect: redirect_2
    });
    t5 = redirect_3 => strategyUrls.createTrial({
      absoluteDomainName,
      redirect: redirect_3
    });
    $[5] = absoluteDomainName;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== siteModel.urls.myAccount || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      createLogin: t1,
      createLogout: t2,
      createLogoutToLogin: t3,
      createProfile: t4,
      createTrial: t5,
      manageAccount: siteModel.urls.myAccount
    };
    $[8] = siteModel.urls.myAccount;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const urls = t6;
  let t7;
  if ($[13] !== urls || $[14] !== user) {
    t7 = {
      configuration: keycloakConfiguration,
      urls,
      user
    };
    $[13] = urls;
    $[14] = user;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const provision = t7;
  let t8;
  if ($[16] !== children || $[17] !== provision) {
    t8 = <UserKeycloakAuthenticationContext value={provision}>{children}</UserKeycloakAuthenticationContext>;
    $[16] = children;
    $[17] = provision;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}